import template from './cadastralReferenceMobile.html';
import controller from './cadastralReferenceMobile.controller';
import './cadastralReferenceMobile.scss';

let cadastralReferenceMobileComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default cadastralReferenceMobileComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/cadastralReferenceMobile/cadastralReferenceMobile.component.js